<script setup lang="ts">
defineProps<{ as?: "div" | "li" }>();
</script>

<template>
  <component :is="as || 'li'" class="list-banner">
    <div v-if="$slots.before" class="before">
      <slot name="before" />
    </div>
    <slot />
  </component>
</template>

<style lang="scss" scoped>
@use "@/styles/variables/colors";
@use "@/styles/mixins/typography";

.list-banner {
  @include typography.small("medium");

  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 8px;
  background-color: colors.$background-grey-light;
  color: colors.$text;

  .before {
    display: flex;
    color: colors.$icon-subtle;
  }
}
</style>
